import React from 'react';
import LoginPage from './LoginPage';

/**
 * Mire de connexion / inscription en surimpression (sans barre d’icônes du haut).
 */
export default function AuthModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10001,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        backgroundColor: 'rgba(0,0,0,0.45)',
      }}
      onClick={onClose}
    >
      <div
        style={{ position: 'relative', maxWidth: 440, width: '100%', maxHeight: '90vh', overflowY: 'auto' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          aria-label="Fermer"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 2,
            width: 36,
            height: 36,
            border: 'none',
            borderRadius: 8,
            background: 'rgba(0,0,0,0.06)',
            cursor: 'pointer',
            fontSize: 22,
            lineHeight: 1,
            color: '#2c3e50',
          }}
        >
          ×
        </button>
        <div style={{ paddingTop: 8 }}>
          <LoginPage embedded onClose={onClose} />
        </div>
      </div>
    </div>
  );
}
